import { useState } from "react";
import { pressData } from "../../data/press.ts";

function PressItem({ image, title, organization, date, excerpt, url }: { image: string; title: string; organization: string; date: string; excerpt: string; url: string }) {
  const [hover, setHover] = useState(false);
  return (
    <div
      className={`relative h-full rounded-xl transition-colors cursor-pointer ${hover ? 'bg-white' : 'bg-transparent'}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => window.open(url, "_blank")}
    >
      <div className="flex h-full flex-col md:flex-row gap-4 p-4">
        <div className="w-full md:w-[184px] h-[184px] relative overflow-hidden rounded-md flex-shrink-0">
          <img src={image} alt="Press" className={`absolute inset-0 w-full h-full object-cover ${hover ? 'opacity-100' : 'opacity-100'}`} />
          {!hover && <div className="absolute inset-0 bg-[#00499d]/50" />}
        </div>
        <div className="flex-1 flex flex-col">
          <h3 className={`font-bold text-lg ${hover ? 'text-[#00499d]' : 'text-white'}`}>{title}</h3>
          <div className={`text-xs ${hover ? 'text-[#00499d]/60' : 'text-white/60'}`}>{organization} • Posted {date}</div>
          <p className={`mt-2 text-sm ${hover ? 'text-[#00499d]' : 'text-white'}`}>{excerpt}</p>
          <div className="mt-auto" />
        </div>
      </div>
      <div className="absolute inset-0 border border-white/50 rounded-xl pointer-events-none" />
    </div>
  );
}

export default function LatestPressSection() {
  return (
    <section id="press" className="bg-[#00499d] py-10 md:py-16 lg:py-[100px]">
      <div className="max-w-[1200px] mx-auto text-white">
        <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 px-4 md:px-8 lg:px-0">Latest Press</h2>
        <div className="flex flex-col gap-4 md:gap-5 px-4 md:px-0">
          <div className="flex flex-col lg:flex-row gap-4 md:gap-5 items-stretch w-full">
            {pressData.slice(0, 2).map((p) => (
              <PressItem key={p.id} image={p.image} title={p.title} organization={p.organization} date={p.date} excerpt={p.excerpt} url={p.url} />
            ))}
          </div>
          <div className="flex flex-col lg:flex-row gap-4 md:gap-5 items-stretch w-full">
            {pressData.slice(2, 4).map((p) => (
              <PressItem key={p.id} image={p.image} title={p.title} organization={p.organization} date={p.date} excerpt={p.excerpt} url={p.url} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}



